import { Reveal, Eyebrow } from "./Reveal";
import { IMG } from "../data/content";

const STATS = [
    ["07", "Experience Zones"],
    ["≈90", "Minute Journey"],
    ["04", "Hosted Languages"],
    ["365", "Days a Year"],
];

const About = () => (
    <section id="about" data-testid="about-section" className="bg-heritage-parchment py-24 md:py-36">
        <div className="mx-auto grid max-w-7xl gap-16 px-5 md:grid-cols-2 md:items-center md:px-10 lg:gap-24">
            <div data-testid="about-ihcc-content">
                <Reveal>
                    <Eyebrow>About IHCC · Museum, Gallery &amp; Cultural Centre</Eyebrow>
                    <h2 className="mt-6 font-serif text-3xl font-medium leading-tight tracking-tight text-heritage-ink sm:text-4xl lg:text-5xl">
                        A Living Home for{" "}
                        <em className="text-heritage-terra">Indian Heritage</em> in George Town
                    </h2>
                </Reveal>
                <Reveal delay={0.12}>
                    <p className="mt-8 text-base leading-relaxed text-heritage-ink/75">
                        The Indian Heritage Cultural Centre (IHCC) is a museum, Indian heritage
                        gallery and cultural centre in George Town, Penang — established to
                        preserve, present and celebrate Indian heritage through wide-ranging
                        historic collections and immersive spatial design. Every room is composed
                        so that objects are not merely displayed, but encountered.
                    </p>
                    <p className="mt-5 text-base leading-relaxed text-heritage-ink/75">
                        Inside a heritage shophouse at 57 Lebuh Pantai, the collection spans
                        heritage artefacts, vintage memorabilia, traditional cultural objects and
                        everyday pieces of history — from Tanjore paintings, mud statues and tin
                        toys to vintage scooters and the quiet machinery of another era. IHCC is a
                        collaborative heritage initiative of experienced collectors, cultural
                        visionaries and architectural expertise, conserving artefacts of historical
                        and cultural importance in a meaningful, educational and accessible manner.
                    </p>
                </Reveal>
                <Reveal delay={0.2}>
                    <div className="mt-12 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-heritage-terra/15 bg-heritage-terra/15 sm:grid-cols-4">
                        {STATS.map(([n, label]) => (
                            <div key={label} className="bg-heritage-cream px-5 py-6">
                                <p className="font-serif text-3xl font-semibold text-heritage-terra">
                                    {n}
                                </p>
                                <p className="mt-2 font-mono text-[9px] uppercase tracking-[0.22em] text-heritage-ink/60">
                                    {label}
                                </p>
                            </div>
                        ))}
                    </div>
                </Reveal>
            </div>

            <Reveal delay={0.15} className="relative">
                <div className="absolute -left-4 -top-4 h-full w-full rounded-2xl border border-heritage-gold/40" />
                <div className="group relative overflow-hidden rounded-2xl">
                    <img
                        src={IMG.mural}
                        alt="Inside the IHCC Indian heritage gallery in Penang — hand-painted elephant mural, vintage lanterns and patterned heritage tiles"
                        className="h-[420px] w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.05] md:h-[560px]"
                        loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-heritage-ink/45 via-transparent to-transparent" />
                    <p className="absolute bottom-5 left-5 font-mono text-[10px] uppercase tracking-[0.25em] text-heritage-parchment/90">
                        The Heritage Gallery · Fig. 01
                    </p>
                </div>
            </Reveal>
        </div>
    </section>
);

export default About;
